var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"download\">\n    <path d=\"M11.875 5.625H9.375V1.875H5.625V5.625H3.125L7.5 10L11.875 5.625ZM3.125 11.25V12.5H11.875V11.25H3.125Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol